// extracted by mini-css-extract-plugin
module.exports = {"center":"game_center__0CkIK","vs":"game_vs__mhcMR","datePicker":"game_datePicker__yr9kI","gameTime":"game_gameTime__LLNEe","mobileAdmin":"game_mobileAdmin__qsJht"};